<template>
  <div>
    <PortalTarget name="modalPortal"></PortalTarget>
    <PortalTarget name="goAheadModalPortal"></PortalTarget>
    <PortalTarget name="imagePickerModalPortal"></PortalTarget>
    <PortalTarget name="deletePortal"></PortalTarget>
    <PortalTarget name="parentInfoPortal"></PortalTarget>
    <PortalTarget name="extensionPortal"></PortalTarget>
    <PageWrapper>
      <NavbarMain />
      <BaseAlertMessage />
      <OpportunityEditContainer />
      <Footer />
    </PageWrapper>
  </div>
</template>

<script>
import PageWrapper from '@/components/_shared/PageWrapper.vue'
import NavbarMain from '@/components/_shared/navbar-main/NavbarMain.vue'
import OpportunityEditContainer from '@/components/opportunity-edit/OpportunityEditContainer.vue'
import Footer from '@/components/_shared/Footer.vue'

export default {
  name: 'Opportunity',
  components: {
    PageWrapper,
    NavbarMain,
    OpportunityEditContainer,
    Footer
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'opportunity-select') {
      const answer = window.confirm(
        'Hello, if "Ok" a new Reference Number will have to be allocated.\nIn order to retain this Reference Number click "Cancel".\nIf you haven\'t allocated a Reference Number please ignore this message.'
      )
      if (answer) {
        localStorage.setItem('editOpportunity/id', from.params.privateId)
        return next()
      } else {
        return next(false)
      }
    }
    return next()
  }
}
</script>
